export const REQUEST_STATUS = {
    NONE: {loading: false, success: false, error: false},
    LOADING: {loading: true, success: false, error: false},
    SUCCESS: {loading: false, success: true, error: false},
    ERROR: {loading: false, success: false, error: true},
};

export const BULK_LOAD_ERRORS = {
    INVALID_EMAIL: 'Email inválido',
    INVALID_NAME: 'Nombre inválido',
    INVALID_CUIT_OR_CUIL: 'Cuit o cuil inválido',
    INVALID_PHONE_NUMBER: 'Telefono inválido',
    INVALID_PHONE_NUMBER_TYPE: 'Tipo de telefono inválido',
    INVALID_SALESFORCE_PROVIDER_ID: 'Prestador inválido',
    INVALID_SALESFORCE_BRANCH_ID: 'Sede inválida',
    INVALID_ROLE: 'Rol inválido',
    EMAIL_ALREADY_USED: 'Email ya en uso',
    PROVIDER_ADMIN_ALREADY_EXIST: 'Ya existe un administrador para este prestador',
    MISSING_SALESFORCE_BRANCH_ID: 'Falta especificar la sede',
    SALESFORCE_BRANCH_ID_NOT_FROM_PROVIDER: 'La sede no pertenece al prestador',
    ERROR_CREATING_PROVIDER: 'Error al crear el usuario',
    MUST_PROVIDE_CSV_FILE: 'Error al cargar el archivo',
    WRONG_CSV_HEADERS: 'Archivo inválido',
};
